module.exports = "<ns-bind-html html=\"{{text}}\"></ns-bind-html>\n";